module.exports = __webpack_public_path__ + "static/media/hz_bg.4daf3da8.png";